module.exports = __webpack_public_path__ + "img/vertical_4_5_0.e1916a51.png";